import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import { css } from 'emotion'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Helmet from 'react-helmet';

import Section from '../components/section/Section'
import {
  SectionTwoCol,
  SectionColumn
} from '../components/section/SectionTwoCol'
import SectionHeader from '../components/section/SectionHeader'
import SectionPreHeader from '../components/section/SectionPreHeader'
import SubHeader from '../components/section/SubHeader'
import CalloutContainer from '../components/CalloutContainer'

import Button from '../components/buttons/Button'
import PartnersList from '../components/main/PartnersList'
import TestimonialList from '../components/TestimonialsList'
import HeroVideo from '../components/HeroVideo'
import HubspotFormSection from '../components/forms/HubspotFormSection'
import Card from '../components/card'

import {
  TwoCol,
  LeftCol,
  RightCol,
} from '../components/two-col'

import 'react-modal-video/scss/modal-video.scss'

import PhoneImage from '../assets/Phone.png'
import messageBubble from '../assets/message-bubbles.svg'
import analyticsLogo from '../assets/analytics.svg'
import aiLogo from '../assets/ai-icon.svg'
import upsellLogo from '../assets/upsell.svg'
import taskLogo from '../assets/people.svg'
import moreLogo from '../assets/more.svg'
import ChannelsImage from '../assets/channels.svg'
import heroVideo from '../assets/hero-video.mp4'
import heroVideoMobileImg from '../assets/hero-video-mobile.png'
import ProductImage from '../assets/product.png'
import heroImg from '../assets/hero.png'
import starsIcon from '../assets/stars.svg'
import integrationsIcon from '../assets/integrations.svg'
import trianingIcon from '../assets/training.svg'
import voiceIcon from '../assets/voice.svg'
import teamLogo from '../assets/team-communication.svg'
import translateIcon from '../assets/translation.svg'
import chatbotIcon from '../assets/chatbot.svg'
import surveyIcon from '../assets/surveys.svg'
import automateIcon from '../assets/automation.svg'
import headshot1 from '../assets/testimonials/testimonial-headshot-1.png'
import headshot2 from '../assets/testimonials/testimonial-headshot-2.png'
import headshot3 from '../assets/testimonials/testimonial-headshot-3.png'


const sellingPoints = [
  {
    label: 'Unlimited Messaging',
    logo: messageBubble,
    logoAlt: 'Unlimited Messaging'
  },
  {
    label: 'Analytics + Insights',
    logo: analyticsLogo,
    logoAlt: 'Analytics + Insights'
  },
  {
    label: 'Artificial Intelligence',
    logo: aiLogo,
    logoAlt: 'Artificial Intelligence'
  },
  {
    label: 'Upsell Revenue',
    logo: upsellLogo,
    logoAlt: 'Upsell Revenue'
  },
  {
    label: 'Task Management',
    logo: taskLogo,
    logoAlt: 'Task Management'
  }
  ,{
    label: 'and more',
    logo: moreLogo,
    logoAlt: 'and more'
  }
]

const promotedFeatures = [
  {
    label: 'Real-Time Analytics',
    logo: analyticsLogo,
    logoAlt: 'Real-Time Analytics'
  },
  {
    label: 'PMS Integrations',
    logo: integrationsIcon,
    logoAlt: 'PMS Software Integrations'
  },
  {
    label: 'Voice Controlled Intelligence',
    logo: voiceIcon,
    logoAlt: 'Voice Controlled Intelligence'
  },
  {
    label: 'Team Communication',
    logo: teamLogo,
    logoAlt: 'Team Communication'
  },
  {
    label: 'Language Translation',
    logo: translateIcon,
    logoAlt: 'Language Translation'
  },
  {
    label: 'Website Chatbot',
    logo: chatbotIcon,
    logoAlt: 'Website Chatbot'
  }
  ,{
    label: 'Staff Training / Support',
    logo: trianingIcon,
    logoAlt: 'Staff Training / Support'
  }
  ,{
    label: 'Automate Responses',
    logo: automateIcon,
    logoAlt: 'Automate Responses'
  }
  ,{
    label: 'Guest Surveys',
    logo: surveyIcon,
    logoAlt: 'Guest Surveys'
  }
]

const testimonial = {
  partner: `BERLIN ENCORE HOTEL`,
  description: `Whistle has helped us provide exemplary customer service for our guests through convenient communication that is extremely effective and user friendly for our staff. Our reputation management has become a breeze with Whistle’s ability to generate 5 star reviews on TripAdvisor. With its integration with SkyTouch, everything is completely automated which has saved us both time and money. We constantly have guests telling us what a benefit it is to have this system at their fingertips to stay in contact with us.`,
  author: 'Braden Conn | Co-Owner'
}

const testimonials = [
  {
    image: headshot1,
    title: '5 Star Reviews',
    body: 'Whistle has helped us provide exemplary customer service. Our reputation management has become a breeze with Whistle’s ability to generate 5 star reviews on TripAdvisor.',
    author: 'Braden Conn | Co-Owner',
    hotel: 'BERLIN ENCORE HOTEL'
  },
  {
    image: headshot2,
    title: 'Whistle for the Win!!',
    body: 'I absolutely love how Whistle has enabled us to take our guest service to another level while allowing our team to multi-task and get really creative with our guest interactions.',
    author: 'Ravan Lemoine | Director of Front Officer',
    hotel: 'HAMPTON INN & SUITES DENVER'
  },
  {
    image: headshot3,
    title: 'Very Impressed',
    body: 'We have seen an increase in guest and staff interaction—resulting in increased Customer Service Scores. Our staff has also find Whistle to be extremely helpful in streamlining communication.',
    author: 'Jim Johnson | Director of Operations',
    hotel: 'OJAI HOSPITALITY GROUP'
  }
]

const partnersClass = css`
  position: relative;
`

const PartnersHeaderWrapper = styled.div`
  text-align: center;
`

const PartnersButton = css`
`

const PromotedFeatureGrid = styled.div`
  display: flex;
  max-width: 600px;
  flex-wrap: wrap;
`

const PromotedFeature = styled.div(props => `
  flex-direction: ${props.column ? 'column' : 'row'};
  display: flex;
  align-items: center;
  width: ${props.third ? '33%' : '50%'};
  padding: 0 .5rem;
  box-sizing: border-box;

  img {
    width: ${props.column ? '50%' : '30%'};
    margin: 1rem 0;
    height: 70px;
  }

  ${props.column ? `
    p {
      font-size: 1rem;
      line-height: 1.2rem;
      text-align: center;
    }
  ` : `
    p {
      font-size: 1.1rem;
      line-height: 1.4rem;
    }
  `}

`)

const SecondaryHeader = styled.h2`
`

const Bold = styled.span`
  font-weight: bold;
`

const ChannelsImg = styled.img`
  margin-top: 3rem;

  @media (min-width: 800px) {
    margin: 0;
  }
`

const CTAWrapper = styled.div`
  margin-top: 2.5rem;
`

const InfoText = styled.p`
  color: white;
  margin: 0;
`

const StarsIcon = styled.img`
  width: 100px;
`

const CarouselClass = css`
  li.slide {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    filter: grayscale(1);
  }
`


class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      openVideo: false
    }
  }

  render() {
    console.log(this.props)
    return (
      <div>
        <Helmet>
          <script type="application/ld+json">{`
            {
              "@context": "https://schema.org",
              "@type": "SoftwareApplication",
              "name": "Whistle Messaging",
              "applicationCategory": "BusinessApplication",
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "5.0",
                "ratingCount": "8864"
              },
              "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
              }
            }
          `}</script>
        </Helmet>
        <TwoCol>
          <LeftCol bgColor={'#fcc71b'} skew color="#fff">
            <StarsIcon src={starsIcon} alt="Top Rated Hotel Messaging" />
            <InfoText>HotelTech Award Winner</InfoText>
            <h1>{`#1 Hotel Messaging Platform`}</h1>
            <SubHeader uppercase>Contact<Bold>Less.</Bold> Communicate <Bold>More.</Bold></SubHeader>
            <CTAWrapper>
              <CalloutContainer align={'left'}>
                <Button to="/schedule" icon>Book A Demo</Button>
                {/* <RegisterButton /> */}
              </CalloutContainer>
            </CTAWrapper>
          </LeftCol>
          <RightCol image bgImgSrc={heroImg} />
        </TwoCol>
        <TwoCol bgColor={'#18aa7a'}>
          <LeftCol bgColor={'#18aa7a'} color={'#fff'}>
            <SecondaryHeader>MORE FEATURES. <br/>BETTER PRICING. <br/>SMARTER MESSAGING.</SecondaryHeader>
            <SubHeader>Our unique features make us <Bold>different.</Bold></SubHeader>
            <PromotedFeatureGrid>
              {sellingPoints.map(feature => {
                return (
                <PromotedFeature>
                  <img src={feature.logo} alt={feature.logoAlt} loading="lazy" />
                  <p>{feature.label}</p>
                </PromotedFeature>
                )
              })}
            </PromotedFeatureGrid>
          </LeftCol>
          <RightCol skew image bgImgSrc={PhoneImage}>
          </RightCol>
        </TwoCol>
        <HeroVideo
          src={heroVideo}
          mobileImg={heroVideoMobileImg}
        />
        <SectionTwoCol id="partners" light>
          <SectionColumn left>
            <SectionPreHeader>Who we work with</SectionPreHeader>
            <SectionHeader>Trusted by 10,000+ Hoteliers</SectionHeader>
            <CalloutContainer>
              <Button icon to={'/clients'} className={PartnersButton} title="Read their Stories">Read their Stories</Button>
            </CalloutContainer>
          </SectionColumn>
          <SectionColumn>
            <PartnersList
              partners={this.props.data.hotels.edges}
            />
          </SectionColumn>
        </SectionTwoCol>
        <Section>
          <Card item={testimonial} />
        </Section>
        <SectionTwoCol>
          <SectionColumn>
            <img src={ProductImage} alt={'Whistle Products Image'} loading="lazy"/>
          </SectionColumn>
          <SectionColumn right>
            <SectionPreHeader align="right">How it Works</SectionPreHeader>
            <SectionHeader align="right">Respond faster.<br/>Collaborate Better.</SectionHeader>
            <SubHeader align="right">Whistle dashboard seamlessly integrates with your PMS—making it easy to communicate at every touchpoint. </SubHeader>
            <CalloutContainer align="right">
              <Button icon to={'/how-it-works'} className={PartnersButton} title="How Whistle Works">How it works</Button>
            </CalloutContainer>
          </SectionColumn>
        </SectionTwoCol>
        <SectionTwoCol light>
          <SectionColumn left>
            <SectionPreHeader>Instant Integrations</SectionPreHeader>
            <SectionHeader>Property Management Systems</SectionHeader>
            <CalloutContainer>
              <Button icon to={'/integrations'} className={PartnersButton} title="PMS Software">Find your PMS</Button>
            </CalloutContainer>
          </SectionColumn>
          <SectionColumn>
             <Carousel
              showArrows={false}
              showIndicators={false}
              showThumbs={false}
              showStatus={false}
              className={CarouselClass}
              infiniteLoop
              autoPlay={() => true}
              interval={2000}
              transitionTime={500}
             >
             {this.props.data.pms.edges.map(partner => (
                <div key={partner.node.id}>
                  <img
                    src={partner.node.frontmatter.logo}
                    alt={partner.node.frontmatter.title}
                    title={partner.node.frontmatter.title}
                    loading="lazy"
                  />
                </div>
              ))}
            </Carousel>
          </SectionColumn>
        </SectionTwoCol>
        <TwoCol>
          <LeftCol skew bgColor={'#18aa7a'} color={'#fff'}>
            <SectionPreHeader>Messaging Apps</SectionPreHeader>
            <SectionHeader>WE'RE CONNECTED</SectionHeader>
            <SubHeader>With key partnerships and integrations, we make it easy for guests to use their preferred messaging app to make any request at any time.</SubHeader>
          </LeftCol>
          <RightCol image>
            <ChannelsImg src={ChannelsImage} alt={'Whistle Messaging Channels'} loading="lazy"/>
          </RightCol>
        </TwoCol>
        <TwoCol bgColor={'#F8F8F8'}>
          <LeftCol bgColor={'#F8F8F8'}>
            <SectionPreHeader>Features</SectionPreHeader>
            <SectionHeader>MORE THAN A MESSAGING TOOL</SectionHeader>
            <SubHeader>It's a full suite of solutions, integrations and products. </SubHeader>
            <Button icon to="/features">See All Features</Button>
          </LeftCol>
          <RightCol skew color={'#fff'} bgColor={'#fcc71b'}>
            <PromotedFeatureGrid>
              {promotedFeatures.map(feature => {
                return (
                <PromotedFeature third column>
                  <img src={feature.logo} alt={feature.logoAlt} loading="lazy" />
                  <p>{feature.label}</p>
                </PromotedFeature>
                )
              })}
            </PromotedFeatureGrid>
          </RightCol>
        </TwoCol>
        <Section light>
          <SectionPreHeader align="center">Customer Reviews</SectionPreHeader>
          <SectionHeader align="center">LOVED BY BRANDS & INDEPENDENT BOUTIQUES</SectionHeader>
          <TestimonialList testimonials={testimonials} />
        </Section>
        <HubspotFormSection
          id="book-demo"
          formId="7d86c04f-e98e-42eb-ae79-ff2b14c7605a"
          trackingId={process.env.ADWORDS_TRACKER_LEAD_FORM}
        />
      </div>
    )
  }
}

export const pageQuery = graphql`
  query PartnersQuery {
    hotels: allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___order] },
      filter: { frontmatter: { templateKey: { eq: "client" }, featured: { eq: true } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            logo
            order
          }
        }
      }
    }
    pms: allMarkdownRemark(
      sort: { order: ASC, fields: [frontmatter___order] },
      filter: { frontmatter: { templateKey: { eq: "integration" }, type: { eq: "PMS" } }}
    ) {
      edges {
        node {
          excerpt(pruneLength: 400)
          id
          fields {
            slug
          }
          frontmatter {
            title
            logo
            order
          }
        }
      }
    }
  }
`

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js